import { render, staticRenderFns } from "./MergeStatus.vue?vue&type=template&id=ce9c80cc&"
import script from "./MergeStatus.vue?vue&type=script&lang=js&"
export * from "./MergeStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports